export default __webpack_public_path__ + "static/media/fridge2-afterA-1920w.b78a3de7.webp";